module.exports = __webpack_public_path__ + "static/media/memo.702fcce4.svg";